var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceOutlineDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_11248",
    "data-name": "Grupo 11248",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17903",
    "data-name": "Ret\\xE2ngulo 17903",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_002-video-camera",
    "data-name": "002-video-camera",
    d: "M17.813,1.012A.382.382,0,0,0,17.436,1L13.306,3.26V1.907A1.909,1.909,0,0,0,11.4,0H1.907A1.909,1.909,0,0,0,0,1.907V9.436a1.909,1.909,0,0,0,1.907,1.907H11.4a1.909,1.909,0,0,0,1.907-1.907V8.107l4.13,2.255A.381.381,0,0,0,18,10.027V1.34A.381.381,0,0,0,17.813,1.012Zm-5.27,8.424A1.145,1.145,0,0,1,11.4,10.58H1.907A1.145,1.145,0,0,1,.763,9.436V1.907A1.145,1.145,0,0,1,1.907.763H11.4a1.146,1.146,0,0,1,1.144,1.144Zm4.695-.051L13.306,7.238V4.129l3.932-2.146Zm0,0",
    transform: "translate(1 4.329)",
    fill: "#455079",
    stroke: "#455079",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOutlineDark);
export default __webpack_public_path__ + "static/media/device-outline-dark.96b77a723c3a43d555657e830cabb40a.svg";
export { ForwardRef as ReactComponent };